import styled from "styled-components";
import queenGirl from "assets/images/Elle_Tiffany_2021_04_211010_3.gif";

export const Container = styled.section`
  width: 100%;
  min-height: max-content;
  padding: 0 96px;

  @media screen and (max-width: 580px) {
    padding: 0 32px;
  }
`;

export const QueenGirl = styled.img.attrs({ src: queenGirl })`
  width: 100%;
  height: auto;
  object-fit: contain;
`;
